import React from 'react';
import { EyeIcon, LockIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { Card, SectionTitle } from '../components/ui/Card';
import { Switch } from '../components/ui/Switch';
import { metricsForSport, sports } from '../data/sportMetrics';
import { useLocale } from '../contexts/LocaleContext';
import { useMetrics } from '../contexts/MetricsContext';
import { formatMetric } from '../utils/units';
export function PublicMetrics() {
  const {
    t,
    tl
  } = useLocale();
  const metrics = useMetrics();
  return <div className="px-2 pb-2" data-id="element-3541" data-mp="2zsyob8e05vrp">
      <PageHeader title={t('metrics.public.title')} subtitle={t('metrics.public.subtitle')} showBack data-id="element-3542" data-mp="2ut3vv0ekwy4j" />

      <Card className="p-2" data-id="element-3543" data-mp="2pusqb1vbh9s4">
        <p className="flex items-start gap-2 text-[12px] leading-snug text-muted" data-id="element-3544" data-mp="2ptrbqnf3e55n">
          <LockIcon size={14} className="mt-[1px] shrink-0" aria-hidden="true" data-id="element-3545" data-mp="1jeqca7quz4ub" />
          {t('metrics.public.note')}
        </p>
      </Card>

      {sports.map(sport => <section key={sport} className="mt-3" data-id="element-3546" data-mp="i25s9ol786hq">
          <SectionTitle data-id="element-3547" data-mp="i0b666y6y8c2">{t(`category.${sport}`)}</SectionTitle>
          <ul className="rounded-card border border-sand-line bg-white/70 px-2" data-id="element-3548" data-mp="m2zi4ni7bvd9">
            {metricsForSport(sport).map(metric => {
          const isPublic = metrics.isPublic(metric.id);
          return <li key={metric.id} className="flex items-center gap-2 border-b border-sand-line py-2 last:border-b-0" data-id="element-3549" data-mp="d1rj237v2qi4">
                  <span className="min-w-0 flex-1" data-id="element-3550" data-mp="366miklkaifr">
                    <span className="block text-[13px] font-medium text-deep" data-id="element-3551" data-mp="36znt61r4fqi">
                      {tl(metric.label)}
                    </span>
                    <span className="bee-num mt-[2px] block text-[11.5px] text-muted" data-id="element-3552" data-mp="3qjabdzx8ojob">
                      {metric.value > 0 ? formatMetric(metric.kind, metric.value, metrics.unitSystem) : '—'}
                    </span>
                  </span>
                  <span className={`flex shrink-0 items-center gap-1 text-[10.5px] font-medium ${isPublic ? 'text-gold-deep' : 'text-muted'}`} data-id="element-3553" data-mp="2xghnxp8hy0r1">
                    {isPublic ? <EyeIcon size={13} data-id="element-3554" data-mp="2nnimh6rwifq0" /> : <LockIcon size={13} data-id="element-3555" data-mp="2iqjw8zbcysx3" />}
                    {t(isPublic ? 'metrics.publicOn' : 'metrics.publicOff')}
                  </span>
                  <Switch checked={isPublic} onChange={() => metrics.togglePublic(metric.id)} label={`${t('metrics.public.title')} — ${tl(metric.label)}`} data-id="element-3556" data-mp="3gczbrvk85gi0" />
                </li>;
        })}
          </ul>
        </section>)}
    </div>;
}